export const ADD_DYNAMIC_LOCALES = {
    fr: {
        "Manager Modules": 'Modules pour gestionnaires',
        "Common Attacks": 'Attaques courantes',
        "Authentication": '"Authentification"',
        "Data Privacy and Security": 'Confidentialité et sécurité des données',
        "Physical Security": 'Sécurité physique',
        "Online Safety": 'Sécurité en ligne',
        "Educators - Protecting Sensitive Data": 'Éducateurs : Protection des données sensibles',
        "Educators - Online and Email Best Practices": 'Éducateurs: Meilleures pratiques en ligne et par courriel',
        "Educators - Securing Your Digital World": 'Éducateurs: Sécuriser votre monde digital',
    },
    es: {
        "Manager Modules": 'Módulos para gerentes',
        "Common Attacks": 'Ataques comunes',
        "Authentication": '"Autenticación"',
        "Data Privacy and Security": 'Privacidad y seguridad de los datos',
        "Physical Security": 'Seguridad física',
        "Online Safety": 'Seguridad en línea',
        "Educators - Protecting Sensitive Data": 'Educadores: Proteger los datos sensibles',
        "Educators - Online and Email Best Practices": 'Educadores: Mejores prácticas en línea y por correo electrónico',
        "Educators - Securing Your Digital World": 'Educadores: Proteger su mundo digital',
    },
    es_mx: {
        "Manager Modules": 'Módulos para gerentes',
        "Common Attacks": 'Ataques comunes',
        "Authentication": '"Autenticación"',
        "Data Privacy and Security": 'Privacidad y seguridad de los datos',
        "Physical Security": 'Seguridad física',
        "Online Safety": 'Seguridad en línea',
        "Educators - Protecting Sensitive Data": 'Educadores: Proteger los datos sensibles',
        "Educators - Online and Email Best Practices": 'Educadores: Mejores prácticas en línea y por correo electrónico',
        "Educators - Securing Your Digital World": 'Educadores: Proteger su mundo digital',
    },
    pt_br: {
        "Manager Modules": 'Módulos para Gerentes',
        "Common Attacks": 'Ataques comuns',
        "Authentication": '"Autenticação"',
        "Data Privacy and Security": 'Privacidade e segurança dos dados',
        "Physical Security": 'Segurança Física',
        "Online Safety": 'Segurança on-line',
        "Educators - Protecting Sensitive Data": 'Educadores: Proteção de dados sensíveis',
        "Educators - Online and Email Best Practices": 'Educadores: Melhores práticas on-line e de e-mail',
        "Educators - Securing Your Digital World": 'Educadores: Protegendo seu mundo digital',
    },
    pt: {
        "Manager Modules": 'Módulos para Gerentes',
        "Common Attacks": 'Ataques comuns',
        "Authentication": '"Autenticação"',
        "Data Privacy and Security": 'Privacidade e segurança dos dados',
        "Physical Security": 'Segurança Física',
        "Online Safety": 'Segurança on-line',
        "Educators - Protecting Sensitive Data": 'Educadores: Proteção de dados sensíveis',
        "Educators - Online and Email Best Practices": 'Educadores: Melhores práticas on-line e de e-mail',
        "Educators - Securing Your Digital World": 'Educadores: Protegendo seu mundo digital',
    }
}
